import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formPassReset } from '../../actions/authAction';
import {
  Button,
  Form,
 
  Header,
  Segment
} from 'semantic-ui-react';

class FormPassReset extends Component {
  state = {
    uemail: '',
    error: false
  };
  
  backButtonHandler =()=>{
    this.props.history.goBack()
  }

onSubmit =  async(e) =>  {
 
    e.preventDefault();
    //this.ValidateEmail(this.state.uemail)
    const mailformat = /^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const match= mailformat.test(this.state.uemail)
    
    
    this.setState({error : !match });
    
    const userData = {
      uemail: this.state.uemail,
     };
     if(this.state.error===false){
       
      this.props.formPassReset(userData, this.props.history)
    
    this.setState({uemail: '' });
    }
    

};



  onChange = e => {
  
    this.setState({ [e.target.name]: e.target.value });
     this.setState({error : false });
    
  };

  render() {
    
    const { error } = this.state;
  
    return (
      <div style={{maxWidth:'600px',margin:'auto'}}>
        <Segment
          textAlign="center"
          inverted
          color="teal"
          style={{ border: "none" }}
        >
          <Header> Reset Your Password </Header>
        </Segment>
        <Segment
          textAlign="center"
          //inverted
         // color="teal"
          style={{ border: "none" }}
        >
          <Header> Please enter your Registered Email and A Password Reset link will be sent to
          your email.</Header>
        </Segment>
         
          
          <Form size="large" onSubmit={this.onSubmit}>
          <Segment stacked style={{ textAlign:"left" }}>
              
              <label>Enter Your Registered Email</label>
                <Form.Input
                  name="uemail"
                  type="email"
                  value={this.state.uemail}
                  onChange={this.onChange}
                  //error={errors.email}
                  fluid
                  icon="mail"
                  iconPosition="left"
                  placeholder="Enter Your Registered Email"
                />
                <div>
                {
                  error === true && (
                    
                      <span style={{color:'red',fontSize:'16px'}}>
                        <b>Please enter a valid email address!</b>
                      </span>
                     
                    
                  )}
              </div>
                <Button color="teal"  size="mini">
                  Reset Password
                </Button>
                <Button
            color="blue"
            size="mini"
            type="button"
            onClick={()=>this.backButtonHandler()}

          >
            Cancel
          </Button>
            </Segment>
          </Form>
        
      </div>
    );
  }
}


export default connect(
  null,
  { formPassReset }
)(FormPassReset);

//export default FormPassReset;
